/* @jsxImportSource react */

import type { CSSProperties, ReactNode } from 'react';

interface CssWithCustomProperties extends CSSProperties {
  '--min-card-width': string;
}

export type ProductCardGridProps = {
  children: ReactNode;
  defaultMinCardWidth: string;
};

// NOTE: the more obvious approach of using a `gap` in the `ul` and `gap-0` in the `li` does not work, because currently empty grid tracks are not collapsed, and so the gap leads to unexpected whitespace in the individual `li` elements using subgrid
export const ProductCardGrid = ({
  children,
  defaultMinCardWidth,
}: {
  children: ReactNode;
  defaultMinCardWidth: string;
}) => {
  const style: CssWithCustomProperties = {
    '--min-card-width': defaultMinCardWidth,
  };

  return (
    <div className="product-card-grid-wrapper flex flex-col">
      <ul
        className={`product-card-grid min-card-width-${defaultMinCardWidth} grid gap-x-2`}
        style={style}
      >
        {children}
      </ul>
    </div>
  );
};
